import * as api from "./apis";
import { Configuration } from "./runtime";

const HOST = window.location.host;
let accessToken: string | null = null;

let hccBaseUrl: string | null = null;

// use in tenant-provider
export const setHCCAccessToken = (token: string) => {
  accessToken = token;
};

// use in tenant-provider
export const setHCCBaseUrl = (url: string) => {
  // remove trailing slash if present
  hccBaseUrl = url.replace(/\/$/, "");
};

function getFallbackBasePath() {
  const parts = HOST.split(".");
  const protocol = HOST.includes("localhost") ? "http" : "https";
  let apiHost = "hcc-api." + parts.slice(-2).join(".");
  if (HOST.includes("localhost")) apiHost = HOST;
  else if (parts[0] === "test" || parts[0] === "staging") apiHost = "hcc-api." + HOST;
  return `${protocol}://${apiHost}`;
}

function getHCCConfiguration() {
  // new configuration is needed so hccBaseUrl has time to be set (on module load it will be null)
  return new Configuration({
    // Prefer the url from use-frontend-settings (set via setHCCBaseUrl),
    // fall back to deriving the host from window.location.
    basePath: hccBaseUrl ?? getFallbackBasePath(),
    // accessToken is a function so it is evaluated lazily at request time,
    // after the rana auth flow has set the token.
    accessToken: () => accessToken ?? "",
  });
}

export const getHCCApi = () => new api.V3Api(getHCCConfiguration());

export const getHCCBetaApi = () => new api.V3BetaApi(getHCCConfiguration());
